import React from "react";
import { Tabs } from "antd";
import {
  FormOutlined,
  BarChartOutlined,
  SettingOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { Navigate } from "react-router-dom";
import WastageEntryForm from "./WastageEntryForm";
import WastageAnalytics from "./WastageAnalytics";
import BufferConfigManager from "./BufferConfigManager";
import ExcessStockManager from "./ExcessStockManager";
import PageTitle from "../page-header/PageHeader";
import checkTokenExp from "../../utils/checkTokenExp";

const WastageLayout = () => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to="/auth/login" replace />;
  }

  const accessToken = localStorage.getItem("access-token");
  checkTokenExp(accessToken);

  const items = [
    {
      key: "entry",
      label: (
        <span>
          <FormOutlined /> Record Wastage
        </span>
      ),
      children: <WastageEntryForm />,
    },
    {
      key: "analytics",
      label: (
        <span>
          <BarChartOutlined /> Analytics
        </span>
      ),
      children: <WastageAnalytics />,
    },
    {
      key: "excess",
      label: (
        <span>
          <InboxOutlined /> Excess Stock
        </span>
      ),
      children: <ExcessStockManager />,
    },
    {
      key: "buffer",
      label: (
        <span>
          <SettingOutlined /> Buffer Config
        </span>
      ),
      children: <BufferConfigManager />,
    },
  ];

  return (
    <div>
      <PageTitle title="Back" />
      <Tabs defaultActiveKey="entry" items={items} size="large" />
    </div>
  );
};

export default WastageLayout;
